import { render, staticRenderFns } from "./IconRewardExpired.vue?vue&type=template&id=353e5128"
import script from "./IconRewardExpired.vue?vue&type=script&lang=js"
export * from "./IconRewardExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports